import { id, parseMarked, type WordSense, type ExampleSentence } from "./domain";
// Original teaching examples authored for Sentence; not a scraped dictionary or an accredited CEFR list.
// lemma | Turkish sense | part of speech | US IPA | marked sentence | translation | collocation | common error | level
const source = `
use|kullanmak|verb|/juːz/|I [use] my phone every day.|Telefonumu her gün kullanırım.|use a phone||A1
mistake|hata|noun|/mɪˈsteɪk/|I made a [mistake] yesterday.|Dün bir hata yaptım.|make a mistake|do a mistake yerine make a mistake kullanılır.|A2
need|ihtiyaç duymak|verb|/niːd/|I [need] some water.|Biraz suya ihtiyacım var.|||A1
want|istemek|verb|/wɑːnt/|I [want] a cup of tea.|Bir fincan çay istiyorum.|||A1
like|sevmek; hoşlanmak|verb|/laɪk/|I [like] this song.|Bu şarkıyı seviyorum.|||A1
know|bilmek|verb|/noʊ/|Do you [know] her name?|Onun adını biliyor musun?|||A1
think|düşünmek|verb|/θɪŋk/|I [think] this is your bag.|Sanırım bu senin çantan.|||A1
understand|anlamak|verb|/ˌʌndərˈstænd/|I [understand] the question.|Soruyu anlıyorum.|||A1
learn|öğrenmek|verb|/lɝːn/|I [learn] a new word every day.|Her gün yeni bir kelime öğrenirim.|learn a word||A1
remember|hatırlamak|verb|/rɪˈmembər/|I [remember] your name.|Adını hatırlıyorum.|||A1
forget|unutmak|verb|/fərˈɡet/|Please don't [forget] your keys.|Lütfen anahtarlarını unutma.|||A1
read|okumak|verb|/riːd/|I [read] before bed.|Yatmadan önce kitap okurum.|read a book||A1
write|yazmak|verb|/raɪt/|Please [write] your name here.|Lütfen adını buraya yaz.|||A1
speak|konuşmak|verb|/spiːk/|Do you [speak] English?|İngilizce konuşuyor musun?|speak English||A1
listen|dinlemek|verb|/ˈlɪsən/|I [listen] to music on the bus.|Otobüste müzik dinlerim.|listen to music|listen music yerine listen to music kullanılır.|A1
hear|duymak|verb|/hɪr/|I can [hear] a dog outside.|Dışarıda bir köpeğin sesini duyabiliyorum.|||A1
see|görmek|verb|/siː/|I can [see] the ocean.|Okyanusu görebiliyorum.|||A1
watch|izlemek|verb|/wɑːtʃ/|We [watch] a movie on Fridays.|Cuma günleri bir film izleriz.|watch a movie||A1
look for|aramak|phrase|/lʊk fɔːr/|I need to [look for] my keys.|Anahtarlarımı aramam gerekiyor.|||A2
find|bulmak|verb|/faɪnd/|I can't [find] my phone.|Telefonumu bulamıyorum.|||A1
give|vermek|verb|/ɡɪv/|Please [give] me a minute.|Lütfen bana bir dakika ver.|||A1
take|almak|verb|/teɪk/|You can [take] this chair.|Bu sandalyeyi alabilirsin.|||A1
bring|getirmek|verb|/brɪŋ/|Please [bring] a jacket.|Lütfen bir ceket getir.|||A1
buy|satın almak|verb|/baɪ/|I need to [buy] some milk.|Biraz süt almam gerekiyor.|||A1
pay|ödemek|verb|/peɪ/|Can I [pay] by card?|Kartla ödeyebilir miyim?|pay by card||A1
cost|fiyatı olmak|verb|/kɔːst/|How much does it [cost]?|Fiyatı ne kadar?|||A1
open|açmak|verb|/ˈoʊpən/|Please [open] the window.|Lütfen pencereyi aç.|||A1
close|kapatmak|verb|/kloʊz/|Please [close] the door.|Lütfen kapıyı kapat.|||A1
start|başlamak|verb|/stɑːrt/|We [start] work at nine.|İşe saat dokuzda başlarız.|start work||A1
finish|bitirmek|verb|/ˈfɪnɪʃ/|I [finish] work at five.|İşim saat beşte biter.|finish work||A1
wait|beklemek|verb|/weɪt/|Please [wait] here.|Lütfen burada bekle.|||A1
help|yardım etmek|verb|/help/|Can you [help] me?|Bana yardım edebilir misin?|||A1
ask|sormak|verb|/æsk/|Can I [ask] a question?|Bir soru sorabilir miyim?|ask a question||A1
answer|yanıt; cevap|noun|/ˈænsər/|I don't know the [answer].|Cevabı bilmiyorum.|||A1
call|telefon etmek|verb|/kɔːl/|I'll [call] you tonight.|Bu akşam seni arayacağım.|||A1
meet|tanışmak|verb|/miːt/|It's nice to [meet] you.|Seninle tanıştığıma memnun oldum.|||A1
leave|ayrılmak; çıkmak|verb|/liːv/|We need to [leave] now.|Şimdi çıkmamız gerekiyor.|||A1
arrive|varmak|verb|/əˈraɪv/|We [arrive] at the airport at noon.|Havaalanına öğlen varırız.|arrive at the airport|arrive to yerine bağlama göre arrive at veya arrive in kullanılır.|A1
live|yaşamak; ikamet etmek|verb|/lɪv/|I [live] in a small town.|Küçük bir kasabada yaşıyorum.|||A1
work|çalışmak|verb|/wɝːk/|I [work] in a hotel.|Bir otelde çalışıyorum.|||A1
study|ders çalışmak|verb|/ˈstʌdi/|I [study] after dinner.|Akşam yemeğinden sonra ders çalışırım.|||A1
cook|yemek pişirmek|verb|/kʊk/|We [cook] at home on Sundays.|Pazar günleri evde yemek pişiririz.|||A1
eat|yemek yemek|verb|/iːt/|I [eat] breakfast at seven.|Saat yedide kahvaltı yaparım.|eat breakfast||A1
drink|içmek|verb|/drɪŋk/|I [drink] water with lunch.|Öğle yemeğinde su içerim.|||A1
sleep|uyumak|verb|/sliːp/|I [sleep] for eight hours.|Sekiz saat uyurum.|||A1
walk|yürümek|verb|/wɔːk/|We [walk] to school.|Okula yürüyerek gideriz.|||A1
drive|araba sürmek|verb|/draɪv/|I [drive] to work.|İşe arabayla giderim.|||A1
travel|seyahat etmek|verb|/ˈtrævəl/|I like to [travel] by train.|Trenle seyahat etmeyi severim.|||A1
try|denemek|verb|/traɪ/|Can I [try] this soup?|Bu çorbayı deneyebilir miyim?|||A1
choose|seçmek|verb|/tʃuːz/|You can [choose] a seat.|Bir koltuk seçebilirsin.|||A2
change|değiştirmek|verb|/tʃeɪndʒ/|I need to [change] my password.|Şifremi değiştirmem gerekiyor.|||A2
keep|saklamak|verb|/kiːp/|Please [keep] the receipt.|Lütfen fişi sakla.|||A2
feel|hissetmek|verb|/fiːl/|I [feel] better today.|Bugün kendimi daha iyi hissediyorum.|||A1
enjoy|keyif almak|verb|/ɪnˈdʒɔɪ/|I [enjoy] cooking.|Yemek pişirmekten keyif alırım.|enjoy cooking|enjoy to cook yerine enjoy cooking kullanılır.|A2
explain|açıklamak|verb|/ɪkˈspleɪn/|Can you [explain] this word?|Bu kelimeyi açıklayabilir misin?|||A2
practice|pratik yapmak|verb|/ˈpræktɪs/|I [practice] English every morning.|Her sabah İngilizce pratik yaparım.|||A1
water|su|noun|/ˈwɔːtər/|Can I have some [water]?|Biraz su alabilir miyim?|||A1
coffee|kahve|noun|/ˈkɔːfi/|I'd like a [coffee], please.|Bir kahve istiyorum, lütfen.|a cup of coffee||A1
bread|ekmek|noun|/bred/|We need some [bread].|Biraz ekmeğe ihtiyacımız var.|||A1
milk|süt|noun|/mɪlk/|There is [milk] in the fridge.|Buzdolabında süt var.|||A1
rice|pirinç; pilav|noun|/raɪs/|I'd like chicken and [rice].|Tavuk ve pilav istiyorum.|||A1
fruit|meyve|noun|/fruːt/|I eat [fruit] every day.|Her gün meyve yerim.|||A1
breakfast|kahvaltı|noun|/ˈbrekfəst/|What time is [breakfast]?|Kahvaltı saat kaçta?|have breakfast||A1
lunch|öğle yemeği|noun|/lʌntʃ/|Let's have [lunch] together.|Birlikte öğle yemeği yiyelim.|have lunch||A1
dinner|akşam yemeği|noun|/ˈdɪnər/|What's for [dinner]?|Akşam yemeğinde ne var?|have dinner||A1
menu|menü|noun|/ˈmenjuː/|Can I see the [menu]?|Menüyü görebilir miyim?|||A1
order|sipariş|noun|/ˈɔːrdər/|Is this your [order]?|Bu sizin siparişiniz mi?|take an order||A1
order|sipariş vermek|verb|/ˈɔːrdər/|I'd like to [order] a salad.|Bir salata sipariş etmek istiyorum.|order a meal||A1
order|düzen|noun|/ˈɔːrdər/|Please put these files in [order].|Lütfen bu dosyaları düzene koy.|in order||A2
check|hesap; restoran hesabı|noun|/tʃek/|Can we have the [check], please?|Hesabı alabilir miyiz, lütfen?|||A1
table|masa|noun|/ˈteɪbəl/|We need a [table] for two.|İki kişilik bir masaya ihtiyacımız var.|||A1
seat|oturacak yer; koltuk|noun|/siːt/|Is this [seat] free?|Bu koltuk boş mu?|||A1
reservation|rezervasyon|noun|/ˌrezərˈveɪʃən/|I have a [reservation].|Rezervasyonum var.|make a reservation||A2
guest|misafir|noun|/ɡest/|Our [guest] is here.|Misafirimiz burada.|||A2
room|oda|noun|/ruːm/|Your [room] is ready.|Odanız hazır.|||A1
key|anahtar|noun|/kiː/|Here is your [key].|İşte anahtarınız.|||A1
bag|çanta|noun|/bæɡ/|This [bag] is heavy.|Bu çanta ağır.|||A1
phone|telefon|noun|/foʊn/|My [phone] is in my bag.|Telefonum çantamda.|||A1
money|para|noun|/ˈmʌni/|I need some [money] for the bus.|Otobüs için biraz paraya ihtiyacım var.|||A1
price|fiyat|noun|/praɪs/|What is the [price] of this bag?|Bu çantanın fiyatı ne kadar?|||A1
receipt|fiş; makbuz|noun|/rɪˈsiːt/|Can I have a [receipt]?|Fiş alabilir miyim?|||A2
store|mağaza|noun|/stɔːr/|The [store] opens at nine.|Mağaza saat dokuzda açılır.|||A1
street|sokak|noun|/striːt/|The bank is on this [street].|Banka bu sokakta.|||A1
city|şehir|noun|/ˈsɪti/|This is a beautiful [city].|Burası güzel bir şehir.|||A1
home|ev; kişinin yaşadığı yer|noun|/hoʊm/|I'm at [home] today.|Bugün evdeyim.|at home||A1
family|aile|noun|/ˈfæməli/|My [family] lives nearby.|Ailem yakınlarda yaşıyor.|||A1
friend|arkadaş|noun|/frend/|She is my [friend].|O benim arkadaşım.|||A1
neighbor|komşu|noun|/ˈneɪbər/|Our [neighbor] has a dog.|Komşumuzun bir köpeği var.|||A2
job|iş; meslek|noun|/dʒɑːb/|I like my new [job].|Yeni işimi seviyorum.|||A1
office|ofis|noun|/ˈɔːfɪs/|The [office] is on the second floor.|Ofis ikinci katta.|||A1
meeting|toplantı|noun|/ˈmiːtɪŋ/|The [meeting] starts at ten.|Toplantı saat onda başlıyor.|have a meeting||A2
email|e-posta|noun|/ˈiːmeɪl/|I sent you an [email].|Sana bir e-posta gönderdim.|send an email||A1
question|soru|noun|/ˈkwestʃən/|I have a [question].|Bir sorum var.|ask a question||A1
problem|sorun|noun|/ˈprɑːbləm/|There is a [problem] with my phone.|Telefonumda bir sorun var.|solve a problem||A1
idea|fikir|noun|/aɪˈdiːə/|That's a good [idea].|Bu iyi bir fikir.|||A1
time|zaman|noun|/taɪm/|Do you have [time] for a walk?|Yürüyüş için zamanın var mı?|||A1
today|bugün|adverb|/təˈdeɪ/|I'm busy [today].|Bugün meşgulüm.|||A1
tomorrow|yarın|adverb|/təˈmɑːroʊ/|See you [tomorrow].|Yarın görüşürüz.|||A1
yesterday|dün|adverb|/ˈjestərdeɪ/|I called her [yesterday].|Onu dün aradım.|||A1
early|erken|adverb|/ˈɝːli/|Please come [early].|Lütfen erken gel.|||A1
late|geç kalan; gecikmiş|adjective|/leɪt/|The bus is [late].|Otobüs gecikti.|||A1
busy|meşgul|adjective|/ˈbɪzi/|Are you [busy] right now?|Şu anda meşgul müsün?|||A1
ready|hazır|adjective|/ˈredi/|The food is [ready].|Yemek hazır.|||A1
easy|kolay|adjective|/ˈiːzi/|This question is [easy].|Bu soru kolay.|||A1
difficult|zor|adjective|/ˈdɪfɪkəlt/|This word is [difficult] to say.|Bu kelimeyi söylemek zor.|||A1
important|önemli|adjective|/ɪmˈpɔːrtənt/|This meeting is [important].|Bu toplantı önemli.|||A1
different|farklı|adjective|/ˈdɪfərənt/|We have [different] jobs.|Farklı işlerimiz var.|||A1
same|aynı|adjective|/seɪm/|We take the [same] bus.|Aynı otobüse biniyoruz.|||A1
enough|yeterli; yeterince|determiner|/ɪˈnʌf/|We have [enough] chairs.|Yeterince sandalyemiz var.|||A2
hungry|aç|adjective|/ˈhʌŋɡri/|I'm [hungry] after work.|İşten sonra acıkıyorum.|||A1
thirsty|susamış|adjective|/ˈθɝːsti/|Are you [thirsty]?|Susadın mı?|||A1
tired|yorgun|adjective|/ˈtaɪərd/|I'm [tired] tonight.|Bu akşam yorgunum.|||A1
delicious|lezzetli|adjective|/dɪˈlɪʃəs/|This soup is [delicious].|Bu çorba çok lezzetli.|||A2
expensive|pahalı|adjective|/ɪkˈspensɪv/|This jacket is [expensive].|Bu ceket pahalı.|||A1
cheap|ucuz|adjective|/tʃiːp/|The tickets are [cheap].|Biletler ucuz.|||A1
near|yakınında|preposition|/nɪr/|The hotel is [near] the station.|Otel istasyonun yakınında.|||A1
between|arasında; iki şeyin arasında|preposition|/bɪˈtwiːn/|The bank is [between] the store and the hotel.|Banka, mağaza ile otelin arasında.|||A1
always|her zaman|adverb|/ˈɔːlweɪz/|I [always] bring a bag.|Her zaman bir çanta getiririm.|||A1
usually|genellikle|adverb|/ˈjuːʒuəli/|I [usually] walk to work.|İşe genellikle yürüyerek giderim.|||A1
sometimes|bazen|adverb|/ˈsʌmtaɪmz/|We [sometimes] eat out.|Bazen dışarıda yemek yeriz.|||A1
never|hiçbir zaman|adverb|/ˈnevər/|I [never] drink coffee at night.|Geceleri hiç kahve içmem.|||A1
take a break|mola vermek|phrase|/teɪk ə breɪk/|Let's [take a break].|Bir mola verelim.|||A2
make a decision|karar vermek|phrase|/meɪk ə dɪˈsɪʒən/|We need to [make a decision].|Bir karar vermemiz gerekiyor.||do a decision yerine make a decision kullanılır.|A2
get ready|hazırlanmak|phrase|/ɡet ˈredi/|I need to [get ready] for work.|İş için hazırlanmam gerekiyor.|||A2
take an order|sipariş almak|phrase|/teɪk ən ˈɔːrdər/|Can you [take an order] now?|Şimdi sipariş alabilir misin?|||A2
have a seat|oturmak; buyurup oturmak|phrase|/hæv ə siːt/|Please [have a seat].|Lütfen oturun.|||A1
go shopping|alışverişe gitmek|phrase|/ɡoʊ ˈʃɑːpɪŋ/|Let's [go shopping] tomorrow.|Yarın alışverişe gidelim.|||A1
on time|vaktinde|phrase|/ɑːn taɪm/|The train is [on time].|Tren vaktinde geliyor.|||A2
right now|şu anda|phrase|/raɪt naʊ/|I can't talk [right now].|Şu anda konuşamıyorum.|||A1
excuse me|affedersiniz; dikkat çekmek için|phrase|/ɪkˈskjuːz miː/|[Excuse me], is this your bag?|Affedersiniz, bu sizin çantanız mı?|||A1
thank you|teşekkür ederim|phrase|/θæŋk juː/|[Thank you] for your help.|Yardımın için teşekkür ederim.|||A1
you're welcome|rica ederim|phrase|/jʊr ˈwelkəm/|[You're welcome]. Have a nice day.|Rica ederim. İyi günler.|||A1
how much|ne kadar; fiyat sormak için|phrase|/haʊ mʌtʃ/|[How much] is this shirt?|Bu gömlek ne kadar?|||A1
would like|istemek; kibarca|phrase|/wʊd laɪk/|I [would like] some tea.|Biraz çay istiyorum.|||A1
check in|giriş işlemi yapmak|phrase|/tʃek ɪn/|I'd like to [check in].|Giriş yapmak istiyorum.|||A2
turn left|sola dönmek|phrase|/tɝːn left/|[Turn left] at the bank.|Bankanın oradan sola dön.|||A1
pick up|alıp götürmek; birini almak|phrase|/pɪk ʌp/|Can you [pick up] the kids?|Çocukları alabilir misin?|||A2
look after|bakmak; ilgilenmek|phrase|/lʊk ˈæftər/|I [look after] my sister on Fridays.|Cuma günleri kız kardeşimle ilgilenirim.|||A2
run out of|tükenmek; bitirmek|phrase|/rʌn aʊt əv/|We might [run out of] milk.|Sütümüz bitebilir.|||A2
`;
export const starterRows = source
  .trim()
  .split("\n")
  .map((line, i) => {
    const [lemma, meaning, pos, ipa, marked, tr, collocation, commonError, cefr] =
      line.split("|");
    const wordId = "starter-" + String(i + 1).padStart(3, "0"),
      createdAt = "2026-11-04T00:00:00.000Z";
    const kind = pos === "phrase" ? "phrase" : "word";
    const deckIds = [
      cefr === "A1" ? "a1" : "a2",
      ...(kind === "phrase" ? ["phrases"] : []),
      ...(/order|menu|check|reservation|guest|room|table|seat|breakfast|lunch|dinner/.test(
        lemma,
      )
        ? ["restaurant"]
        : []),
    ];
    const word: WordSense = {
      id: wordId,
      lemma,
      sense: meaning,
      meaning,
      pos,
      ipa,
      cefr: cefr as WordSense["cefr"],
      kind,
      collocations: collocation ? [collocation] : [],
      commonError,
      tags: [cefr, "örnek"],
      deckIds,
      notes:
        "Sentence için hazırlanmış örnek içerik. Düzey etiketleri yaklaşık öğretim düzeyidir.",
      favorite: false,
      difficult: false,
      active: true,
      deleted: false,
      source: "starter",
      createdAt,
    };
    const example: ExampleSentence = {
      id: wordId + "-example",
      wordId,
      ...parseMarked(marked),
      tr,
      createdAt,
    };
    return { word, example };
  });
export function suggest(lemma: string) {
  return starterRows.filter(
    (r) =>
      r.word.lemma.toLocaleLowerCase("en-US") ===
      lemma.trim().toLocaleLowerCase("en-US"),
  );
}
export function copyStarter(row: (typeof starterRows)[number]) {
  const wordId = id(),
    now = new Date().toISOString();
  return {
    word: {
      ...row.word,
      id: wordId,
      source: "personal" as const,
      deckIds: ["personal"],
      tags: [],
      createdAt: now,
      notes: "",
    },
    example: { ...row.example, id: id(), wordId, createdAt: now },
  };
}
